import axios from '@/libs/axios'

const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/letters/sent/', { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const askedQuotes = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/main-total-quote/', { params: queryParams })
    .then(response => {
      commit('ASK_QUOTE_LIST', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const sendAskQuote = (_, askQuote) => {
  const formData = new FormData()
  const fields = ['about', 'period', 'dc_amount', 'phd_amount',
    'phd_targeted_amount', 'dc_targeted_amount', 'trainee_amount']
  fields.forEach(field => {
    formData.append(field, askQuote[field])
  })
  if (askQuote.base64) formData.append('file', askQuote.base64)
  return axios.post('/main-total-quote/ask_quote/', formData)
}
const orgDistributedQuote = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/org-distribute-quote/get_org_distributed_quote/', { params: queryParams })
    .then(response => {
      commit('ORG_DISTRIBUTED_QUOTE', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const get = ({ commit }, id) => new Promise((resolve, reject) => {
  axios.get(`/letters/${id}`)
    .then(response => {
      commit('GET', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const getQuoteDistribution = ({ commit }, id) => new Promise((resolve, reject) => {
  axios.get(`/main-total-quote/${id}`)
    .then(response => {
      commit('SET_QUOTE_DISTRIBUTION', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const updateItem = (ctx, data) => axios.patch('/org-distribute-quote/org_update_confirmed_amount/', data.body, { params: { period_id: data.periodId } })

const updateAdditionalItem = (ctx, { dc_types, letter_id }) => axios.patch('/org-distribute-quote/org_update_additional_confirmed_amount/', dc_types, { params: { letter_id } })
const changeLetterQuoteStep = (ctx, id) => axios.patch(`/letters/${id}/change_letter_quote_step/`, [])
const getBalance = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/main-total-quote/balance_base_quote_org/', { params: queryParams })
    .then(response => {
      commit('OTM_BALANCE', response.data.ans)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const getAdditionalBalance = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/main-total-quote/org_additional_balance/', { params: queryParams })
    .then(response => {
      commit('OTM_ADDITIONAL_BALANCE', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const additionalQuotes = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/main-total-quote/', { params: queryParams })
    .then(response => {
      commit('ADDITIONAL_QUOTE_LIST', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
export default {
  list,
  orgDistributedQuote,
  get,
  updateItem,
  getBalance,
  changeLetterQuoteStep,
  additionalQuotes,
  askedQuotes,
  sendAskQuote,
  getQuoteDistribution,
  getAdditionalBalance,
  updateAdditionalItem,
}
